import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Colors from '../colors';
import Text from '../text';
import Button from '../button';
import Spacer from '../spacer';
import Container from './container';
const StyledButtonContainer = styled.View`
  flex-direction: row;
  margin-left: auto;
`;
const styles = {
  referral: {
    paddingVertical: 21
  }
};
export default function Referral(props) {
  return /*#__PURE__*/React.createElement(Container, {
    style: styles.referral
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    color: Colors.gray600
  }, props.children), /*#__PURE__*/React.createElement(StyledButtonContainer, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  }), /*#__PURE__*/React.createElement(Button.Text, {
    size: "small",
    onPress: props.shareOnPress
  }, "SHARE"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(Button.Text, {
    size: "small",
    onPress: props.copyOnPress
  }, "COPY")));
}
Referral.defaultProps = {
  children: '',
  shareOnPress: () => {},
  copyOnPress: () => {}
};
Referral.propTypes = {
  children: PropTypes.node,
  shareOnPress: PropTypes.func,
  copyOnPress: PropTypes.func
};
//# sourceMappingURL=referral.js.map